import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { ClubLogo } from "./ClubLogo";

export function PageHeader({ title, subtitle, back = false, action }) {
  const navigate = useNavigate();
  return (
    <header className="page-header" data-testid={`${title.toLowerCase().replaceAll(" ", "-")}-header`}>
      <div className="header-title-group">
        {back && <button className="icon-button" onClick={() => navigate(-1)} aria-label="Voltar" data-testid="back-button"><ChevronLeft /></button>}
        {!back && <ClubLogo size="small" />}
        <div><h1>{title}</h1>{subtitle && <p data-testid="header-subtitle">{subtitle}</p>}</div>
      </div>
      {action}
    </header>
  );
}
